var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.btnClass,style:(_vm.btnStyle),attrs:{"type":_vm.btnType}},[_c('span',{staticClass:"btn__text t-ttu t-tdn"},[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }